module.exports = __webpack_public_path__ + "img/bonus_phone_km.444036c8.png";